<template>
  <div class="bar bg-282B80">
    <div class="position-relative flex flex-center mach-height">
      <div class="logo cursor" @click="toHome">
        <!-- <img src="../assets/icon-lib-logo-bg.png" alt=""> -->
        <img :src="clients.logoMain" alt="">
        <!-- <img src="@/assets/image@2x.png" alt=""> -->
      </div>
      <div class="navigate flex flex-center">
        <!-- <div class="navigate-item flex flex-center radius-clip-6" :class="navigatorIndex==0?'navigate-item-sel':''" @click="toHome">
          <p class="navigate-item-text font-size-14 " :class="navigatorIndex==0?'font-white':''">首页</p>
        </div> -->
        <div class="navigate-item flex flex-center radius-clip-6" :class="navigatorIndex==1?'navigate-item-sel':''" @click="toList">
          <p class="navigate-item-text font-size-16 font-color-white"  :class="navigatorIndex==1?'font-white':''">{{clients.collectionTheme?clients.collectionTheme:''}}</p>
          <!-- 数字特藏 -->
        </div>
        <div class="navigate-item flex flex-center radius-clip-6">
          <div class="navigate-line bg-white" />
        </div>
        <!-- 馆藏一级分类 -->
        <div class="category">
          <div class="category-list flex flex-center">
              <div            
                v-for="(item,index) in categoryList"
                :key="index"
                class="category-list-item cursor"
                @click="toSearchCategory(item, index)"
                :class="navigatorIndexs==index?'font-bold':''"
                > 
                <p class="category-list-item-text font-size-14">{{ item.cateName }}</p>
              </div>
          </div>
        </div>
        <!-- <div class="navigate-item flex flex-center radius-clip-6" :class="navigatorIndex==2?'navigate-item-sel':''" @click="toDiscover">
          <p class="navigate-item-text font-size-14 font-color-white"  :class="navigatorIndex==2?'font-white':''">探索</p>
        </div> -->
        <!-- <div class="navigate-item flex flex-center radius-clip-6">
          <div class="navigate-line bg-white" />
        </div> -->
      </div>

      <div class="logon-and-create flex ">
        <div v-if="token" class="navigate-item flex  radius-clip-6 cursor" :class="navigatorIndex==3?'navigate-item-sel':''" @click="toMine">
          <p class="navigate-item-text font-size-16 font-color-white"  :class="navigatorIndex==3?'font-white':''">我的</p>
        </div>
        <div v-else class="navigate-item flex  radius-clip-6 cursor" :class="navigatorIndex==4?'navigate-item-sel':''" @click="toLogin">
          <p class="navigate-item-text font-size-16 font-color-white"  :class="navigatorIndex==4?'font-white':''">登录</p>
        </div>
        <div class="navigate-item radius-clip-6">
          <div class="navigate-bias-line bg-white" />
        </div>
        <div class="navigate-item flex radius-clip-6 cursor" :class="navigatorIndex==5?'navigate-item-sel':''" @click="toUpload" >
          <p class="navigate-item-text font-size-16 font-color-white"  :class="navigatorIndex==5?'font-white':''">创建</p>
        </div>

        <div v-if="token" class="navigate-item flex radius-clip-6 cursor" :class="navigatorIndex==6?'navigate-item-sel':''" @click="exite" style="margin-left: 20px;">
          <p class="navigate-item-text font-size-16 font-color-white"  :class="navigatorIndex==6?'font-white':''">退出</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import navg from '../models/navigations.js
import api from '../api/home.js'
import auth from '../models/auth.js'
import user from '../models/user.js'
import searchModel from "../models/search.js";
import {
  mapState
} from 'vuex'
export default {
  data() {
    return {
      navigatorIndexs: '-1',
      currentSelectNavigateIndex: 0,
      clients: {},
      categoryList: [],
      navigateListData: [{
        text: '首页',
        id: 0,
        name: 'Home',
        path: '/',
        select: false
      }, {
        text: '数字特藏',
        id: 1,
        name: 'Collection',
        path: '/collection',
        select: false
      }, {
        text: '探索',
        id: 2,
        name: 'Discovery',
        path: '/discover',
        select: false
      }, {
        text: null,
        id: 3,
        name: '',
        path: '',
        select: false
      }, {
        text: '我的',
        id: 4,
        name: 'User',
        path: '/user',
        select: false
      }, {
        text: '创建',
        id: 5,
        name: 'Single',
        path: '/single',
        select: false
      }],
      navigateUnloginData: [{
        text: '首页',
        id: 0,
        name: 'Home',
        path: '/',
        select: false
      }, {
        text: '数字特藏',
        id: 1,
        name: 'Collection',
        path: '/collection',
        select: false
      }, {
        text: '探索',
        id: 2,
        name: 'Discovery',
        path: '/discover',
        select: false
      }, {
        text: null,
        id: 3,
        name: '',
        path: '',
        select: false
      }, {
        text: '登录',
        id: 11,
        name: 'Login',
        path: '/login',
        select: false
      }, {
        text: '创建',
        id: 5,
        name: 'Single',
        path: '/single',
        select: false
      }]

    }
  },
  computed: {
    ...mapState({
      token: state => state.user.token,
      navigatorIndex: state => state.navigation.navigatorIndex
    })
  },
  created() {
    // this.navigateListData = navg.navigateList()
    // this.currentSelectNavigateIndex = 0
    // const that = this
    // for (let i = 0; i < this.navigateListData.length; i++) {
    //   const v = this.navigateListData[i]
    //   if (that.$route.path === v.path) {
    //     that.currentSelectNavigateIndex = i
    //     break
    //   }
    // }
    let that = this;
    setTimeout(() => {
      that.clients = that.$store.getters.application  
    }, 1500);
    this.requestCategoryList();
  },
  methods: {
    toSearchCategory(v,index) {
      this.navigatorIndexs = index
      this.$store.dispatch("search/setType", 1);
      this.$store.dispatch("search/setKeyword", "");
      searchModel.viewData = {
        params: { categoryId: v.id },
        display: v.cateName,
        type: "categoryId"
      };
      this.$router.push({ 
        name: "Collection",
        query:{
          name: v.cateName,
          categoryId: v.id 
        }
       });

      console.log('v',v)
      // this.$store.dispatch("search/setType", 1);
      // // // this.$store.dispatch("search/setKeyword", "");
      // searchModel.viewData = {
      //   params: { categoryId: v.id },
      //   display: v.cateName,
      //   type: "categoryId"
      // };
      
      // this.$store.commit('user/TITLES',v.cateName)
      // console.log('this.$store',this.$store.state.user.titles)
      // console.log('234234',v.cateName)
      // this.$router.push({ 
      //   name: "Collection",
      //   // params:{
      //   //   name: '12'
      //   // }
      // });
    },
        //获取分类
    requestCategoryList() {
      let that = this;
      api
        .categoryList({ tenantId: this.$store.getters.tenantId })
        .then(r => {
          that.categoryList = [];
           r.data.forEach((element,index)=> {
                if(index<12){
                    that.categoryList.push(element);
                }
            });
        })
        .catch(err => {
          console.log(err);
        });
    },
    // click() {
    //   this.$store.dispatch('user/logout')
    // },
    toHome() {
      this.$store.dispatch('navigation/setNavigatorIndex', 0)
      this.$router.push({
        path: '/'
      })
    },
    toList() {
      this.$store.dispatch('search/setType', 1)

      this.$store.dispatch('navigation/setNavigatorIndex', 1)
      this.$router.push({
        path: '/collection'
      })
      if (this.$router.history.current.fullPath === '/collection') {
        location.reload()
        return
      }
    },
    toDiscover() {
      this.$store.dispatch('navigation/setNavigatorIndex', 2)
      this.$router.push({
        path: '/discover'
      })
    },
    toMine() {
      this.$store.dispatch('navigation/setNavigatorIndex', 4)
      this.$router.push({
        path: '/user'
      })
    },
    toLogin() {
      this.$store.dispatch('navigation/setNavigatorIndex', 4)
      this.$router.push({
        path: '/login'
      })
    },
    toUpload() {
      if (!auth.gettoken()) {
        this.$router.push({
          name: 'Login',
          query: { r: '/single', skip: 'n' }
        })
        return
      }
      console.log(user.getUserData())
      const userdata = user.getUserData()
      if (userdata.typeCode && userdata.typeCode !== 'P0') {
        const routeData = this.$router.resolve({
          path: '/single'
        })
        window.open(routeData.href, '_blank')
      } else {
        this.$router.push({
          path: '/auth',
          query: { r: '/single', skip: 'n' }
        })
      }
    },
    exite() {
      this.$store.dispatch('user/logout')
      user.clean()
      this.$store.dispatch('navigation/setNavigatorIndex', 0)
      this.$router.push({
        path: '/'
      })
    }
  }
}
</script>

<style src="@/styles/pc.css" scoped>
</style><style scoped>
.font-white{
  color: #fff !important;
}
.bar {
  width: 100%;
  height: 70px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  color: white;
  font-size: 24px;
  min-width: 1240px;
  z-index: 4999;
  background: #282B80;
  padding: 0px 30px;
}

.logo {
  position: absolute;
  top: 0;
  left: -30px;
  bottom: 0;
}

.logo img {
  width: auto;
  height: 100%;
}

.navigate {
  height: 100%;
}

.navigate .navigate-item {
  height: 38px;
  /* padding: 0 15px; */
  /* margin-right: 10px; */
  cursor: pointer;
}

.navigate .navigate-item-sel {
  /* background-color: rgba(0, 0, 0, 0.2); */
}

.navigate .navigate-item .navigate-item-text {
  color: #fff;
  /* color: rgba(255, 255, 255, 0.5); */
}
.navigate .navigate-item .navigate-item-text:hover{
   color: #fff;
}
.navigate .navigate-item .navigate-item-text:active{
   color: #fff;
}
.navigate .navigate-item .navigate-line {
  width: 1px;
  height: 9.15px;
  margin-left: 15px;
  margin-right: 15px;
}
/* .flex-center{
  justify-content: right;
} */
/* .flex-center{
  justify-content: center;
  } */
.flex-center{
  justify-content: center;
}
/* @media screen and (max-width: 1500px) {
  .flex-center{
  justify-content: center;
  }
} */
@media screen and (max-width: 1500px) {
  .flex-center{
  transform: translate(20px);
  }
}

.category-list{ 
  height: 38px;
}
.category-list-item {

  margin-right: 22px;
  color: #FFF;
}

.category-list-item:last-child{
  margin-right: 0px;
}
/* @media screen and (min-width: 1500px) {
  .logon-and-create{
    position: absolute;
    right: 30px;
  }
} */
/* @media screen and (max-width: 1300px) {
  .logon-and-create{
    position: absolute;
    right: 30px;
  }
} */

.logon-and-create{
  /* margin-right: 30px; */
  position: absolute;
  right: 0px;
  /* text-align: right; */
}
@media screen and (max-width: 1500px) {
  .logon-and-create{
  /* margin-right: 30px; */
  position: absolute;
  right: 30px;
  /* text-align: right; */
}
}
.navigate-bias-line {
  /* position: absolute; */
  /* top: 6px; */
  width: 1px;
  height: 16px;
  margin-left: 15px;
  margin-right: 15px;
  -webkit-transform: rotate(20deg);
}
</style>
